import { useSyncExternalStore } from "react";

const MOBILE_QUERY = "(max-width: 767px), (orientation: landscape) and (max-height: 500px)";
const LANDSCAPE_QUERY = "(orientation: landscape) and (max-height: 500px)";
const WIDE_QUERY = "(min-width: 1280px)";

function createMediaHook(query: string) {
  function subscribe(callback: () => void) {
    const mql = window.matchMedia(query);
    mql.addEventListener("change", callback);
    return () => mql.removeEventListener("change", callback);
  }

  function getSnapshot() {
    return window.matchMedia(query).matches;
  }

  function getServerSnapshot() {
    return false;
  }

  return { subscribe, getSnapshot, getServerSnapshot };
}

const mobile = createMediaHook(MOBILE_QUERY);
const wide = createMediaHook(WIDE_QUERY);
const landscape = createMediaHook(LANDSCAPE_QUERY);

export function useIsMobile(): boolean {
  return useSyncExternalStore(mobile.subscribe, mobile.getSnapshot, mobile.getServerSnapshot);
}

export function useIsWide(): boolean {
  return useSyncExternalStore(wide.subscribe, wide.getSnapshot, wide.getServerSnapshot);
}

export function useIsLandscape(): boolean {
  return useSyncExternalStore(
    landscape.subscribe,
    landscape.getSnapshot,
    landscape.getServerSnapshot
  );
}
